/**
 * RecommendationCard Component
 * Displays a single recommendation with poster, details, and watch link
 */

import React from 'react';

function RecommendationCard({ recommendation, onSeen, onWatch }) {
    const {
        title,
        type,
        runtime,
        overview,
        posterPath,
        availableOn = [],
        watchLink,
        voteAverage,
        runtimeLabel,
        watchLabel
    } = recommendation;

    /**
     * Format runtime to human-readable string
     */
    const formatRuntime = (mins) => {
        if (!mins) return 'Unknown';
        if (mins < 60) return `${mins}m`;
        const hours = Math.floor(mins / 60);
        const minutes = mins % 60;
        return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
    };

    /**
     * Get fallback poster if none available
     */
    const getPoster = () => {
        if (posterPath) return posterPath;
        // Fallback gradient based on title
        return null;
    };

    const poster = getPoster();

    return (
        <div className="recommendation-card">
            {/* Poster */}
            <div className="card-poster">
                {poster ? (
                    <img src={poster} alt={title} loading="lazy" />
                ) : (
                    <div className="poster-fallback">
                        <span>{title.charAt(0)}</span>
                    </div>
                )}

                {/* Type Badge */}
                <div className="type-badge">
                    {type === 'movie' ? '🎬 Movie' : '📺 Series'}
                </div>
            </div>

            {/* Content */}
            <div className="card-content">
                <h3 className="card-title">{title}</h3>

                {/* Meta Info */}
                <div className="card-meta">
                    <span className="runtime">{type === 'tv' ? `${runtimeLabel || 'Episode length'}: ` : ''}{formatRuntime(runtime)}</span>
                    {voteAverage && (
                        <span className="rating">⭐ {voteAverage.toFixed(1)}</span>
                    )}
                </div>

                {/* Description */}
                <p className="card-description">
                    {overview && overview.length > 150
                        ? `${overview.substring(0, 150)}...`
                        : overview || 'No description available.'}
                </p>

                {/* Streaming Availability */}
                {availableOn && availableOn.length > 0 && (
                    <div className="availability">
                        <span className="availability-label">Available on:</span>
                        <div className="availability-badges">
                            {[...new Set(availableOn)].map((service, idx) => (
                                <span key={idx} className="service-badge">
                                    {service}
                                </span>
                            ))}
                        </div>
                    </div>
                )}

                {/* Verified offer link */}
                {watchLink && (
                    <a
                        href={watchLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-watch"
                        onClick={onWatch}
                    >
                        {watchLabel || 'Find provider'} →
                    </a>
                )}
                {onSeen && <button type="button" className="btn btn-secondary" onClick={onSeen}>Already seen</button>}

            </div>
        </div>
    );
}

export default RecommendationCard;
